<script setup lang="ts">
import type { ComputedRef } from "vue";
import { SelectScrollDownButton, type SelectScrollDownButtonProps, useForwardProps } from "reka-ui";

const props = withDefaults(defineProps<SelectScrollDownButtonProps>(), {});
// Only the set props; typed as such (see HPixSelectArrow).
const forwarded = useForwardProps(props) as ComputedRef<SelectScrollDownButtonProps>;
</script>

<template>
  <SelectScrollDownButton v-bind="forwarded">
    <slot />
  </SelectScrollDownButton>
</template>
